import moment from 'moment';

function asingAttendace2Day(data, dateFrom, dateTo, holidays) {
    const date_from = getRealDate(dateFrom);
    const date_to = getRealDate(dateTo);
    let arrayOfDays = generateRangeOfDays(date_from, date_to);
    for (let i = 0; i < arrayOfDays.length; i++) {
        for (let j = 0; j < data.length; j++) {
            const element = arrayOfDays[i];
            const isHoliday = holidays.some(objeto => objeto.date === element.date);
            if (arrayOfDays[i].date == data[j].date) {
                arrayOfDays[i] = { ...data[j], ...arrayOfDays[i]};
            }
            arrayOfDays[i].holidays = isHoliday; 
        }
    }

    return arrayOfDays;
}

function generateRangeOfDays(from, to) {
    const options = { weekday: "long" };
    let arrayDays = [];
    const currentDate2 = new Date(from);
    const today = new Date();
    today.setDate(today.getDate() + 1);

    if (currentDate2 > to) {
        console.error(
            "La fecha de inicio debe ser menor o igual que la fecha de fin."
        );
        return arrayDays;
    }
    while (currentDate2 <= to) {
        var current = new Date(currentDate2);

        arrayDays.push({
            day: current.toLocaleString("en-EN", options),
            date: moment(current).format("YYYY-MM-DD"),
            past_date: current < today,
            holidays: false
        });
        currentDate2.setDate(currentDate2.getDate() + 1);
    }

    return arrayDays;
}

function getRealDate(str) {
    const [year, month, day] = str.split("-").map(Number);
    return new Date(Date.UTC(year, month - 1, day + 1));
}


export default { asingAttendace2Day };